"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AnimatedDialogContent = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _dialog = require("@reach/dialog");
var _react = _interopRequireDefault(require("react"));
var _reactSpring = require("react-spring");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Cross = _interopRequireDefault(require("../../svg/Cross.svg"));
var _ArrowLeft = _interopRequireDefault(require("../../svg/ArrowLeft.svg"));
var _UnreachableCaseError = require("../../entities/UnreachableCaseError");
var _excluded = ["children", "open", "onClose", "allowPinchZoom", "config", "contentRef", "dialogRef", "onBack"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Modal = function Modal(_ref) {
  var children = _ref.children,
    open = _ref.open,
    onClose = _ref.onClose,
    _ref$allowPinchZoom = _ref.allowPinchZoom,
    allowPinchZoom = _ref$allowPinchZoom === void 0 ? true : _ref$allowPinchZoom,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? 'default' : _ref$config,
    contentRef = _ref.contentRef,
    dialogRef = _ref.dialogRef,
    onBack = _ref.onBack,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var transitions = (0, _reactSpring.useTransition)(open, {
    from: {
      opacity: 0,
      left: -10
    },
    enter: {
      opacity: 1,
      left: 0
    },
    leave: {
      opacity: 0,
      left: 10
    },
    config: typeof config === 'string' ? _reactSpring.config[config] : config
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, transitions(function (_ref2, item) {
    var opacity = _ref2.opacity;
    return item &&
    /*#__PURE__*/
    // props will get passed to the Content component
    _react["default"].createElement(AnimatedDialogOverlay, Object.assign({}, props, {
      style: {
        opacity: opacity
      },
      onDismiss: onClose,
      allowPinchZoom: allowPinchZoom,
      initialFocusRef: false,
      ref: dialogRef
    }), /*#__PURE__*/_react["default"].createElement(AnimatedDialogContent, {
      "aria-label": "Modal",
      ref: contentRef
    }, onBack && /*#__PURE__*/_react["default"].createElement(BackButton, {
      onClick: onBack
    }, /*#__PURE__*/_react["default"].createElement(_ArrowLeft["default"], null)), /*#__PURE__*/_react["default"].createElement(CloseButton, {
      onClick: onClose,
      "aria-label": "Close Modal"
    }, /*#__PURE__*/_react["default"].createElement(_Cross["default"], null)), children));
  }));
};
var _default = exports["default"] = Modal;
var CloseButton = _styledComponents["default"].button.withConfig({
  displayName: "Modal__CloseButton",
  componentId: "sc-1fiv1u5-0"
})(["display:flex;position:absolute;padding:0;top:2.4rem;right:2.4rem;height:2.4rem;width:2.4rem;> svg{margin:auto;}outline:none;z-index:", ";&:hover{background:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.zIndices.modal;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.neutral['5'];
});
var BackButton = _styledComponents["default"].button.withConfig({
  displayName: "Modal__BackButton",
  componentId: "sc-1fiv1u5-1"
})(["display:flex;position:absolute;padding:0;top:2.4rem;left:2.4rem;height:2.4rem;width:2.4rem;> svg{margin:auto;}outline:none;z-index:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.zIndices.modal;
});
var largeCss = (0, _styledComponents.css)(["width:calc(100vw - 4.8rem);max-width:", ";margin:auto;", "{> svg{transform:scale(1.4);}}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.mediaQueries.xxl;
}, CloseButton);
var regularCss = (0, _styledComponents.css)(["width:56rem;"]);
var smallCss = (0, _styledComponents.css)(["width:34rem;"]);
var fullscreenCss = (0, _styledComponents.css)(["width:100%;max-width:unset;max-height:unset;height:100%;border-radius:0;@media screen and (min-width:", "){padding-top:3.2rem;", "{right:3.2rem;top:3.2rem;}}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.mediaQueries.s;
}, CloseButton);
var getCss = function getCss(variant) {
  if (typeof window !== 'undefined' && window.location.pathname.includes('/embed/')) {
    return fullscreenCss;
  }
  switch (variant) {
    case 'full':
      return fullscreenCss;
    case 'large':
      return largeCss;
    case 'regular':
      return regularCss;
    case 'small':
      return smallCss;
    default:
      throw new _UnreachableCaseError.UnreachableCaseError(variant);
  }
};
var AnimatedDialogOverlay = (0, _reactSpring.animated)((0, _styledComponents["default"])(_dialog.DialogOverlay).withConfig({
  displayName: "Modal__AnimatedDialogOverlay",
  componentId: "sc-1fiv1u5-2"
})(["z-index:", ";display:flex;> [data-reach-dialog-content]{overflow:auto;width:100%;background:", ";position:relative;outline:none;box-shadow:0 1.6rem 2.4rem 0 rgba(59,118,160,0.03),0 2.4rem 8rem 0 rgba(59,118,160,0.05);margin:0;@media screen and (min-width:", "){max-height:90vh;max-width:90vw;margin:auto;padding:", ";border-radius:0.8rem;", "}}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.zIndices.modal;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.neutral['0'];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.mediaQueries.s;
}, function (_ref11) {
  var _ref11$variant = _ref11.variant,
    variant = _ref11$variant === void 0 ? 'large' : _ref11$variant;
  return variant === 'regular' ? '3.2rem' : '2.4rem';
}, function (_ref12) {
  var _ref12$variant = _ref12.variant,
    variant = _ref12$variant === void 0 ? 'large' : _ref12$variant;
  return getCss(variant);
}));
var AnimatedDialogContent = exports.AnimatedDialogContent = (0, _reactSpring.animated)(_dialog.DialogContent);
//# sourceMappingURL=Modal.js.map